import { render, staticRenderFns } from "./glucide.vue?vue&type=template&id=33ea429c&"
import script from "./glucide.vue?vue&type=script&lang=js&"
export * from "./glucide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports